// @flow

import _ from 'lodash';

import type { MemberType } from 'web-core/types/member';
import { type UsageLevelType } from 'client/constants/health';
import BaseApplicantInput from 'client/models/health/BaseApplicantInput';
import type { SessionMemberDrugType } from 'client/models/health/DrugInfoModel';

export const hasMissingMemberInfo = (members: Array<MemberType>) => {
  if (_.isEmpty(members)) {
    return true;
  }
  return _.reduce(
    members,
    (hasMissingInfo, m) => {
      /** only doing this because of eslint no-return-assign and no-param-reassign limitation */
      const hasMissingInformation = _.isNil(m.age) || _.isNil(m.gender) || _.isNil(m.tobacco);
      return hasMissingInfo || hasMissingInformation;
    },
    false,
  );
};

export const getBaseApplicantInputs = (
  members: Array<Object>,
  usageLevel?: UsageLevelType,
  providers: Array<number> = [],
  drugs: Array<SessionMemberDrugType> = [],
): Array<Object> =>
  _.map(
    members,
    ({ age, gender, id, illnesses, tobacco, type }) =>
      new BaseApplicantInput({
        age,
        gender,
        isTobaccoUser: tobacco === true,
        preConditions: illnesses,
        type,
        uuid: id,
        usageLevel,
        providers,
        drugs,
      }),
  );
